import * as React from "react";
import styled from "styled-components";
import theme from "../../assets/css/theme";
import {
	EN_LANG,
	PROJECT_LANG,
	getCurrentLang,
	isLanguageToggleEnabled,
	setLanguage,
} from "modules/utils/language";
import {Exist} from "../Exist";
import {partial} from "lodash";

interface ILangButtonProps {
	readonly $active: boolean;
}

const ToggleWrapper = styled.div`
	display: flex;
	align-items: center;
	margin-right: 12px;
	font-family: ${theme.menu_font};
`;

const LangButton = styled.button<ILangButtonProps>`
	background: transparent;
	border: none;
	cursor: pointer;
	padding: 0 4px;
	color: ${({$active}) => ($active ? "#ffffff" : theme.menu_color)};
	font-family: ${theme.menu_font};
	font-size: 14px;
	font-weight: bold;
	line-height: 18px;
	text-transform: uppercase;
	opacity: ${({$active}) => ($active ? 1 : 0.7)};

	&:hover {
		color: #ffffff;
		opacity: 1;
	}
`;

const Separator = styled.span`
	color: ${theme.menu_color};
	font-size: 14px;
	line-height: 18px;
	opacity: 0.7;
	user-select: none;
`;

export const LanguageToggle: React.FC = () => {
	const currentLang = getCurrentLang();

	return (
		<Exist when={isLanguageToggleEnabled}>
			<ToggleWrapper role="group" aria-label="Language">
				<LangButton
					type="button"
					$active={currentLang === EN_LANG}
					aria-pressed={currentLang === EN_LANG}
					onClick={partial(setLanguage, EN_LANG)}
				>
					{EN_LANG}
				</LangButton>
				<Separator aria-hidden="true">/</Separator>
				<LangButton
					type="button"
					$active={currentLang === PROJECT_LANG}
					aria-pressed={currentLang === PROJECT_LANG}
					onClick={partial(setLanguage, PROJECT_LANG)}
				>
					{PROJECT_LANG}
				</LangButton>
			</ToggleWrapper>
		</Exist>
	);
};

export default LanguageToggle;
